module.exports = __webpack_public_path__ + "img/background-document-detail.47936b93.svg";